import { ClientError } from '@criteria-labs/openapi-runtime'

async function listFiles(projectID: string) {
  const response = await fetch(`/play/api/projects/${projectID}/files`)
  if (!response.ok) {
    if (response.status === 404) {
      throw new ClientError('No project found', { problem: { status: 404 } })
    }
    throw new Error(`Could not list files: ${response.status}`)
  }
  const { items } = await response.json()
  return items
}

export async function downloadProject(projectID: string) {
  const files = await listFiles(projectID)

  const allFiles: Record<string, string> = {}
  for (const { path, href } of files) {
    const response = await fetch(href)
    if (!response.ok) {
      throw new Error(`Could not download file: ${response.status}`)
    }
    const text = await response.text()
    allFiles[path] = text
  }
  return allFiles
}
